export default __webpack_public_path__ + "media/images/icons/monitoring-outline-035c4feaf84fd973f3df0aca4ae364e8.png";